import type { FaireProductEntity } from "../../entity_types/product";

export const p_pdtm3hp3k5: FaireProductEntity = {
  token: "p_pdtm3hp3k5",
  type: "product",
  name: "0.9-1 kg Natural Palo Santo Wood Healing Energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/91237dfc4e06ca56c252894bb7ba4bd2ab4784ecc377ac7054a5ee39fa8edeaf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/52188d8b7aa1bad4aea8be2b40ac57cea82c4f7f3621ae9fc7e4539cec61cd5d.jpeg",
    "https://cdn.faire.com/fastly/a8a85e9e07ac81d34253542015e0f7fa4f24790fe2c4cb1cd6178643d723158a.jpeg",
    "https://cdn.faire.com/fastly/326bae8991beb18111e79763c9be83664d1d2d87a2a63aa1abd9d90296bd48a5.jpeg",
    "https://cdn.faire.com/fastly/93150f9f22ea38d0c90717a9b9bc1a010c5c7c4a8600a310a2fb7c5235e3b3f8.jpeg",
    "https://cdn.faire.com/fastly/8ca8ab43d6bfaf7cc1040b0e6ac0bd1fc673309632c95578ed80e014df832edf.jpeg",
  ],
  priceDollars: 58.2,
  description:
    "2 Packs Natural Palo Santo Wood, weight is 0.9-1 kg Palo Santo. Palo Santo is found in Peru. Condition is New.  \n\nFree local pickup in Brooklyn, New York. \n\nStones, crystals, crystal bulk, crystal wholesale, spiritual, meditation, metaphysical wholesale. ",
  tags: [],
  msrpDollars: 116.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:30.831Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
